import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the offline-first service worker so the app shell stays
// openable on a building site with no signal. Production-only — CRA's
// dev server doesn't serve content-hashed bundles, so caching them would
// poison hot module reload with stale chunks. The SW kicks in on the
// real defectr.co.uk deploy where it actually matters.
//
// The previous SW v1 had a bug where blob: URL fetches were intercepted
// and broke PDF downloads with "Not allowed to load local resource".
// On every page load, we force-update the SW so the new v2 takes effect
// immediately rather than waiting for the browser's normal refresh cycle.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', async () => {
        try {
            const reg = await navigator.serviceWorker.register('/service-worker.js');
            // Force the browser to re-fetch the SW script on every load so
            // bug-fixes propagate fast. Chrome normally checks for SW
            // updates every 24h — we can't wait that long when a SW bug
            // is silently breaking downloads.
            reg.update().catch(() => undefined);
        } catch (err) {
            console.warn('[defectr] SW registration failed', err);
        }
    });
}
